<nav class="navbar sticky-top nav" Id="nav">
  <div class="container-fluid">
    <a class="navbar-brand company_logo_nav" href="/" id="companyLogo"><img src="assets/imgs/zumera-logo-red.png" class="img-fluid nav-logo-image" alt=""></a>

    <!-- Menu temporarily disabled for maintenance mode -->
    <button id="menuBtn" class="navbar-toggler d-none" type="button" disabled (click)="slideNavlinks()" data-bs-toggle="offcanvas" data-bs-target="#offcanvasDarkNavbar" aria-controls="offcanvasDarkNavbar">
      <span class="menu-text">MENU</span>
      <img src="assets/icons/z_icon_black.png" width="30" height="30" class="img-fluid nav-toggle-icon" alt="">
    </button>


    <div class="offcanvas w-50 offcanvas-end " tabindex="-1" id="offcanvasDarkNavbar" aria-labelledby="offcanvasDarkNavbarLabel" #offcanvasNavbar>
      <div class="offcanvas-header">
        <button type="button" class="btn-close btn-close-dark" data-bs-dismiss="offcanvas" aria-label="Close" ></button>
      </div>
      <div class="offcanvas-body overflow-hidden ">
        <ul class="navbar-nav justify-content-end flex-grow-1 ">
          <li class="nav-item dropdown" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
            <a class="nav-link dropdown-toggle"  role="button" data-bs-toggle="dropdown" aria-expanded="false">
              ZUMERA PROJECTS
            </a>
            <ul class="dropdown-menu dropdown-menu-dark">
              <li><a class="dropdown-item">RJ INTERNATIONAL</a></li>
              <li><a class="dropdown-item" routerLink="/projects/Elites-Residence" data-bs-dismiss="offcanvas" aria-label="Close">ELITES RESIDENCE</a></li>
              <li><a class="dropdown-item" routerLink="/projects/Queen-Idia" data-bs-dismiss="offcanvas" aria-label="Close">QUEEN IDIA RESIDENCE</a></li>
            </ul>
          </li>
          <li class="nav-item"(mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
            <a class="nav-link" routerLink="/hospitality" routerLinkActive="active"  data-bs-dismiss="offcanvas" aria-label="Close">ZUMERA HOSPITALITY</a>
          </li>
          <li class="nav-item" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
            <a class="nav-link" routerLink="/what-we-do" data-bs-dismiss="offcanvas" aria-label="Close">ZUMERA EXPERTISE</a>
          </li>
          
          <li class="nav-item dropdown" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
            <a class="nav-link dropdown-toggle" href="#" routerLinkActive="active" role="button" data-bs-toggle="dropdown" aria-expanded="false" >
              ABOUT ZUMERA
            </a>
            <ul class="dropdown-menu dropdown-menu-dark">
              <li><a class="dropdown-item" routerLink="/who-we-are/about-us" data-bs-dismiss="offcanvas" aria-label="Close">ABOUT US</a></li>
              <li><a class="dropdown-item" routerLink="/who-we-are/leadership" data-bs-dismiss="offcanvas" aria-label="Close">LEADERSHIP</a></li>
            </ul>
          </li>
          <li class="nav-item" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
            <a class="nav-link" routerLink="/who-we-are/csr" data-bs-dismiss="offcanvas" aria-label="Close">VALUE CREATION INITIATIVES</a>
          </li>

          <li class="nav-item"(mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
            <a class="nav-link" routerLink="/join-our-tribe"  data-bs-dismiss="offcanvas" aria-label="Close">JOIN THE ZUMERA TRIBE</a>
          </li>
          <li class="nav-item"(mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
            <a class="nav-link" routerLink="/news"  data-bs-dismiss="offcanvas" aria-label="Close">NEWS</a>
          </li>
          <li class="nav-item"(mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
            <a class="nav-link" routerLink="/contact-us"  data-bs-dismiss="offcanvas" aria-label="Close">CONTACT</a>
          </li>
         
        </ul>
      </div>
    </div>
  </div>
</nav>
